export const tr = {
    'error-refresh': 'Hata oluştu. Lütfen, sayfayı yenilemeyi deneyin.',
    'success-cooperation-request':
        'Gerçekleştirdiğiniz sorgu için teşekkürler! Lütfen bir uzmanın sizinle irtibata geçmesini bekleyin veya bu sayfadaki kontaklar içerisinden kendisi ile irtibata geçin'
};
